var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNature(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 36,
    viewBox: "0 0 23 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7897 12.9475L14.4009 13.5606L11.5631 20.249L22.7409 18.889C22.9563 16.9155 22.9727 14.9244 22.7897 12.9475Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0872 20.9066L4.68817 9.57544C3.28786 11.2364 2.15739 13.1185 1.34025 15.1491L6.72297 28.8156L10.0872 20.9066Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9969 0C15.856 1.14897 12.871 2.70547 10.1143 4.63168L13.9994 11.7715L18.9969 0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68339 29.3228L20.0875 26.9484C21.3589 24.826 22.2073 22.4655 22.5835 20.0037L11.0584 21.4138L7.68339 29.3228Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6812 11.8328C22.1869 7.98072 21.2769 4.19713 19.9681 0.551758L14.9164 12.4068L22.6812 11.8328Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4568 13.0534L9.22441 5.28381C7.87649 6.29972 6.61985 7.43756 5.46953 8.68372L10.6569 19.5634L13.4568 13.0534Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.792212 16.7041C-0.699972 21.6869 -0.293013 27.9238 3.81456 35.621L6.11524 30.2201L0.792212 16.7041Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83467 36C7.24387 35.7157 14.6505 34.3613 19.2085 28.2471L7.15705 30.5601L4.83467 36Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNature);
export default __webpack_public_path__ + "static/media/nature.bc016022.svg";
export { ForwardRef as ReactComponent };